export enum PaymentReceiptStatus {
  loading,
  finalizing,
  finalized,
  error,
}